/* eslint-disable import/no-anonymous-default-export */
import Vehicle from "./Vehicle";
import BikeDetails from "./BikeDetails"
export default {
    list: Vehicle,
    show: BikeDetails
}